export default {
  global: {
    noLimit: 'You are not authorized to perform this action, please contact your administrator.',
  },
  text: {
    lang: 'en',
    title: 'JD Cloud Console',
    cabinet: 'Cabinet',
    status: 'Status',
    submission: 'Submit',
    operate: 'Actions',
    confirm: 'Confirm',
    cancel: 'Cancel',
    equipment: 'Device',
    brand: 'Brand',
    model: 'Model',
    belongUbit: 'Unit Location',
    note: 'Notes',
    roomNum: 'Room Number',
    Telecom: 'Telecom',
    Unicom: 'Unicom',
    Mobile: 'CMCC',
    rackUIndex: 'Unit Location',
    normal: 'Normal',
    bandWidth: 'Bandwidth',
    fullName: 'Name',
    enclosure: 'Attachment',
    tel: 'Phone',
    email: 'Email',
    check: 'View',
    checkDetail: 'View',
    revoke: 'Revocation',
    revokeVerb: 'Revoke',
    verify: 'Verify',
    closeTicket: 'Close',
    abnormal: 'Exception',
    pass: 'Pass',
    turnDown: '驳回',
    reject: 'Deny',
    overview: 'Overview',
    notPower: 'Power-off',
    power: 'Power-on',
    inWarehouse: 'In Warehouse',
    onShelf: 'Launched',
    bgp: 'BGP',
    dynamicBGP: 'Dynamic BGP',
    thirdLineBGP: 'Three Line BGP',
    noSearch: 'No Data Now',
    hasSearch: 'No relevant results, please search again',
    delete: 'Delete',
    saveDraft: 'Save Draft',
    submissionNow: 'Submit Now',
    editDraft: 'Please fill in the ticket information and save it',
    sureDelete: 'Confirm to delete ',
    draftTicket: 'the ticket in this draft',
    Maximum500: 'Maximum 500 pieces of data supported',
    moreNode: 'More Co-location',
    entrancePurpose: 'Access Purpose',
    reasonInfo: 'Reason for entering the room',
    choose: 'Please select the {0}',

    resourceBill: 'Resource Bill',
    productType: 'Product Type',
    paymentMethod: 'Payment Method',
    currency: 'Currency',
    accountPeriod: 'Payment Term',
    search: 'Search',
    totalCost: 'Total Cost',
    export: 'Export',
    totalCostTip: 'Original Price+Adjusted Amount',
    costTime: 'Consumption Time',
    price: 'Unit Price',
    dosage: 'Usage',
    changeCalValue: 'Adjustment',
    dosageUnit: 'Usage Unit',
    charge: 'Cost',
    all: 'All',
    postpaid: 'Post paid',
    noBillinginformation: 'No billing information',
    OriginalPrice: 'Original Price',
    AdjustedAmount: 'Adjusted Amount',
    regionInspection: 'Data Center Inspection',
    deviceInspection: 'Device Inspection',
    inspectionDate: 'Inspection Date',
    inspectionTime: 'Inspection Time',
    temperatureValue: 'Temperature Value (℃)',
    humidityValue: 'midity Value (%)',
    arrangementOfArticles: 'rrangement of Articles',
    waterLeakage: 'Water Leakage',
    accessControl: 'Access Control',
    securityMonitoring: 'Security (Monitoring) ',
    fireProtection: 'Fire Protection',
    lightningProtection: 'Lightning Protection',
    airConditioning: 'Air-conditioning',
    powerSupply: 'Power Supply',
    physicalEnvAbnormality: 'Description of Physical Environment Abnormality',
    faultType: 'Fault Type ',
    editTag: 'Edit Tag',
    tags: 'Tag',
    pleaseSelectResource: 'Please select Resource',
    id: 'ID',
    applyId: 'Customer ID',
    start_placeholder: 'Start time',
    end_placeholder: 'End time'
  },
  cabinet: {
    cabinetView: 'Cabinet View',
    cabinetNumCode: 'Cabinet Code',
    cabinetType: 'Cabinet Type',
    billingType: 'Billing Type',
    EnablingStatus: 'Enabling Status',
    EnablingTime: 'Enabling Time',
    cabinetSpace: 'Cabinet Space (U)',
    rentingTime: 'On-hire Time ',
    expireTime: 'Expiration Time',
    reserveStartTime: 'Start Time of Reserve',
    reserveEndTime: 'End Time of Reserve',
    powerUpStatus: 'Powered Status',
    cabinetLockStatus: 'Cabinet locked',
    cabinetDetail: 'Cabinet Details',
    occupyU: 'Occupied(U)',
    freeU: 'Available(U)',
    current: 'Current (A)',
    currentNoUnit: 'Current',
    ratedCurrent: 'Rated Current (A)',
    helpDoc: '{0} Documentation',
    realTimeCurrent: 'Real-time Current (A)',
    utilizationRate: 'Utilization Rate',
    resourceInformation: 'Resource Information',
    dynamicInformation: 'Dynamic Information',
    rangeForSearch: 'Select time range for search',
    start_placeholder: 'Start time',
    end_placeholder: 'End time',
    rangeH: '{0}h',
    rangeD: '{0}d',
    rangeSeparator: ' to ',
    powerTrendChart: 'Cabinet Power Trend Chart',
    period: 'Period',
    maxDays: '(You can query the data up to {0} days of continuous data query.)'
  },
  ip: {
    ipAmount: 'IP Amounts',
    ipType: 'IP Type',
    ipAddress: 'IP Address',
    publicNetIp: 'Public IP',
    netWorkAddr: 'Network Address',
    bordcastAddr: 'Broadcast Address',
    availableAddrSpace: 'Available Address Space',
    ipAddressSegment: 'IP Address Field',
    gatewayAddress: 'Gateway Address',
    helpDoc: '{0} Documentation'
  },
  equipment: {
    cpu: 'CPU',
    memory: 'Memory',
    disk: 'Disk',
    systemIp: 'System IP',
    manageIp: 'Management IP',
    equipmentDetail: 'Device Details',
    snNumber: 'SN Number',
    equipmentType: 'Device Type',
    assetBelonging: 'Asset Category',
    belongInfo: 'Attribution Information',
    equipmentStatus: 'Device Status',
    belongComputerRoom: 'Data Center',
    equipmentList: 'Device List',
    locateUbit: 'Unit Location',
    configInfo: 'Configuration Information',
    equipmentQuantity: 'Device Number',
    helpDoc: '{0} Documentation',
    core: 'Core',
    equipmentNumber: 'Device Code',
    uNo: 'Count（U）',
    // 搜索placeholder
    searchPlaceholder: {
      deviceNo: 'Please enter Device Code for search  ',
      snNo: 'Please enter SN number for search',
      cabinetNo: 'Please enter Cabinet Code for search'
    }
  },
  bandWidth: {
    lineType: 'ISP Line Type',
    chargeType: 'Billing methods',
    bandWidthDetail: 'Bandwidth Details',
    relationPublicNetIp: 'Associated Public IP',
    helpDoc: '{0} Documentation',
    bd: 'Bandwidth',
    name: 'Bandwidth Name',
    contractBandwidth: 'Contract Bandwidth',
    minBandwidth: 'Basic Bandwidth',
    contractMinBandwidth: 'Contract/Basic Bandwidth',
    inputName: 'Please enter  bandwidth name for search',
    inputIp: 'Please enter associated public IP for search'
  },
  ticket: {
    ticketNo: 'Ticket Number',
    remark: 'Description',
    myWork: 'My Ticket',
    workName: 'Ticket Name',
    workType: 'Ticket Type',
    setUpTime: 'Creation Time',
    closeTime: 'Closing Time',
    submissionWork: 'Open Ticket',
    contractEditNum: 'Contract No.',
    deviceCount: '迁入设备数量',
    upLoadWorkTemplate: 'Upload ticket template',
    workDetail: 'Ticket Details',
    workStatus: 'Ticket Status',
    applyInfo: 'Application Information',
    userPin: 'User Pin',
    clickDownload: 'Click to download',
    customerUpload: 'Upload by Customers',
    systemUpload: 'System Upload',
    upLoadFile: 'Upload file ',

    // 工单类型选择页
    assetManagement: 'Asset Management',
    stayTuned: 'Coming Soon',
    deviceChange: 'Device Change',
    accessoriesNotEmpty: 'Attachment cannot be blank',

    // 提交工单页
    applyCabinet: 'Cabinet Initialisation Application Template',
    applyCabinetDownload:
      'Cabinet Initialisation Application Template Download',
    handleSuccess: 'Operate Successfully',
    submitWorksheetError: 'Open ticket failed, please try again!',

    // 工单列表
    to: 'to',
    exportWorksheetList: 'Export current ticket list',
    waitMeProcessed: 'Assigned to Me',
    processing: 'In Progress',
    complete: 'All',

    // 工单详情
    submitApplay: 'Open Ticket',
    pending: 'To be Approved',
    initialInstallation: 'Initialisation Solution',
    verificationProgram: 'Solution Verification',
    implementationDelivery: 'Implementation and Delivery',
    deliveryVerification: 'Delivery Verification',
    toBeOff: 'To be Closed',
    completed: 'Finished',
    constructioDelivery: 'Construction Delivery Form (Verified by customers)',
    verifyConfirmTip:
      '注意：如超过3天未操作，此工单自动核验通过。请您及时处理。',

    verifyConfirm:
      '您的工单申请已经完成设备迁入，请核验交付结果，详细信息查看处理结果的迁入设备列表。',
    // 工单操作
    handleWorksheetError: 'Ticket operation failed, please try again',
    uploadFileSuccess: 'File uploaded',
    cancelReason: 'Cancellation Reason',

    helpDoc: '{0} Documentation'
  },
  overview: {
    resourceInformation: 'Resource Information',
    cabinetInformation: 'Cabinet Information',
    equipmentInformation: 'Device Information',
    publicNetIpInformation: 'Public IP Information',
    bandWidthInformation: 'Bandwidth Information',
    cabinetTotal: 'Cabinet',
    equipmentTotal: 'Device',
    severTotal: 'Server',
    networkEquipmentTotal: 'Network',
    storageEquipmentTotal: 'Storage',
    othersEquipmentTotal: 'Other',
    Enabled: 'Enabled',
    Disabled: 'Disabled',
    Enabling: 'Enabling',
    Disabling: 'Disabling',
    ipTotal: 'Public IP',
    operating: 'Operating',
    changing: 'Changing',
    unsubscribing: 'Closing'
  },
  merge: {
    basicInfo: 'Basic Information',
    roomName: 'Data Center',
    customList: 'Edit Columns',
    helpDoc: 'Help Documentation',
    limitProblem:
      'You can contact online customer service if you have any questions.',
    wordCount: '{0}/256 characters',

    // 附件提交报错
    uploadMax5M:
      'Only one file can be uploaded, please delete it and add another file!',
    uploadShouldBe: 'The uploading file can only be .xls, or .xlsx in format!',
    uploadShouldBe1:
      'The uploading file can only be .png, .jpg or .pdf in format!',
    uploadShouldBeOne:
      'Only one file can be uploaded, please delete it and add another file!',
    uploadShouldBeTwo:
      'Two file can be uploaded, please delete it and add another file!',
    uploadError: 'Attachment upload failed, please try again!',

    // 时间选择
    lastWeek: 'Last Week',
    lastMonth: 'Last Month',
    lastThreeMonth: 'Last Three Months',

    // 没有数据
    noData: 'No Data Now'
  },
  // 设备类型
  devicetypes: {
    type1: 'Server',
    type2: 'Network',
    type3: 'Storage',
    type4: 'Other'
  },
  // 机柜可视化
  cabinetVisual: {
    label: 'Cabinet View',
    label1: 'Cabinet Code: {0} Room Number: {1}',
    tipDeviceNo: 'Device Code: {0}',
    tipSN: 'SN: {0}',
    tipU: 'Unit Location: {0}'
  },

  // 话术部分
  speechcraft: {
    customlist: 'Please select up to 10 information items to display.',
    submitWorkUp:
      'Only 1 attachment can be uploaded, with the size not exceed 5MB and only the formats "xls" and "xlsx" are supported',
    limit:
      'You have not enabled cloud cabinet service, please contact business department. ',
    menulimit: 'You have not enabled {0}, please contact business department. ',
    sonlimit:
      'Current subuser is not authorized to use this product, please contact your administrator',
    rolelimit:
      'Current role is not authorized to use this product, please contact your administrator',
    cpuLogicTotal: 'CPU Logic Core Count',
    ramTotal: 'Total Memory Capacity',
    hardDiskTotal: 'Total Disk Capacity',
    netDiskBandwidth: 'Network Interface Bandwidth',
    relatedIP: 'Associated Public IP',
    // 工单操作部分话术
    revokeTitle:
      'Confirm to revoke the ticket application? If yes, please fill in reasons.',
    verifyPlan:
      'Initial installation scheme design has been finished for your ticket application. Please confirm the initial installation scheme. For details, please view the attachment.',
    verifyPay:
      'Initial installation delivery has been completed for your ticket application. Please verify the delivery results. For details, please see the Attachment, Construction Delivery Form. For any doubts, please contact the business personnel or the sales personnel.',
    iAgree: 'I agree',
    closeTickekTitle:
      'Your ticket application has been processed. Please confirm to close the ticket. If no operation is made within 7 days, the system will automatically close the ticket.',
    // 概览页部分话术
    bandWidthUseInfo: 'Usage Information of Total Bandwidth',
    exportResourceList: 'Export all resource list',
    exportResourceCurrentList: 'Export all resource list',
    lineTypeBandwidth: 'ISP Line Type:Contract/Basic Bandwidth'
  },
  // placeholder提示信息框
  placeholder: {
    cabinetNumCode: 'Please enter cabinet code for search',
    dataTimePicker: 'Please select date creation period',
    // 带宽网段部分
    ipAddressSegment: 'Please enter the IP address field for search',
    ipAddress: 'Please enter associated public IP for search',
    chooseContract: 'Please select Contract No.',
    chooseRemark: 'Please enter note information',
    roomName: 'Please select Data Center',
    choose: 'Please select',
    // 工单撤销
    revoke: 'Please enter reasons for cancellation (compulsory)',
    verifyPlan: 'Please enter deny reasons (compulsory)',
    verifyUploadTip:
      'It can upload 2 attachments, the size of each attachment cannot exceed 3M, the supported formats include"jpg","png","pdf".',
    sn: 'Please enter SN number for search',

    // 工单列表
    worksheetNo: 'Please enter Ticket Number for search',
    worksheetRemark: 'Please enter description for search',
    worksheetName: 'Please enter Ticket Name for search',

    searchMoreCabinetNo:
      'Multiple cabinet codes separated with space can be entered for search',
    searchMoreSN:
      'Multiple SN numbers separated with space can be entered for search',
    searchMoreDeviceNo:
      'Multiple device codes separated with space can be entered for search',
    start_placeholder: 'Start time',
    end_placeholder: 'End time',
  },

  // 设备迁出
  equipmentMoveOut: {
    text: {
      yes: 'Yes',
      no: 'No',
      cancel: 'Cancel',
      ok: 'OK',
      pleaseSubmit: 'Please submit ',
      dc: 'the DC entry ',
      ticket: 'ticket',
      moveOutDate: 'Emigration Date',
      offShelfType: 'Emigration Method',
      turnOff: 'Device Shutdown',
      deliveryType: 'Delivery Method',
      deliveryPersonName: 'Name of Consignee',
      deliveryCertificate: 'Certificate Type of Consignee',
      deliveryNo: 'Certificate No. of Consignee',
      deliveryPhoneNo: 'Phone of Consignee',
      deviceInformation: 'Device Information',
      emigratedDevice: 'Emigrated Device',
      selectEmigratedDevice: 'Select Emigrated Device',
      devicesHaveBeenSelected: '{0} devices have been selected',
      emigrationByCustomer: 'Emigration by Customer',
      JDAgent: 'JD Agent',
      moveOutTip:
        'This ticket only supports move-out of self-prepared devices which have been placed on the shelves'
    },
    placeholder: {
      offShelfType: 'Please select the emigration Method',
      turnOff: 'Please select the device shutdown method',
      deliveryType: 'Please select the delivery method',
      deliveryPersonName: 'Please enter Name of Consignee',
      deliveryCertificate: 'Please select Certificate Type of Consignee',
      deliveryNo: 'Please enter Certificate No. of Consignee',
      deliveryPhoneNo: 'Please enter Phone of Consignee',
      deviceOut: 'Please select the device to be migrated out',
      deviceOutDate: 'Please select the emigration date',
      wrongFormatId: 'Please enter the correct format ID number',
      enterId: 'Please enter the ID number'
    }
  },
  // 人员入室
  roomEntry: {
    uploadFileError: 'Attachment upload failed, please try again!',
    add: 'Add',
    oneEditing: 'Please save the current edit column first.',
    checkNumberOver: 'No more than 100 items can be submitted each time.',
    idCard: 'ID Card',
    passport: 'Passport',
    driverLicense: 'Driving License',
    officer: 'Military ID Card',
    checkInfo: 'Please check the information of DC Entry',
    roomEntryList: 'Personnel List',
    upLoadFile: 'Upload Template',
    edit: 'Edit',
    delete: 'Delete',
    save: 'Save',
    roomEntry: 'DC Entry',
    baseInfo: 'Base Information',
    worksheetType: 'Ticket Type',
    worksheetName: 'Ticket Name',
    customerName: 'Customer Name',
    customerCode: 'Customer Code',
    customerPin: 'User Pin',
    company: 'Enterprise Name',
    mobile: 'Phone',
    email: 'Email',
    computerRoomName: 'Data Center',
    applyInfo: 'Application Information',
    addOne: 'Add Singly',
    addBatch: 'Batch Import',
    deleteBatch: 'Batch Delete',
    selectRoom: 'Please Select',
    download: 'Template Download',
    upload: 'Upload Template',
    uploadWarn:
      'Only 1 attachment can be uploaded, with the size not exceed 5MB and only the formats "xls" "xlsx" and "csv" are supported',
    uploadError:
      'Only one file can be uploaded. Please delete it and add another file',
    uploadFileType: 'Incompatible Uploaded File Format!',
    uploadFileSize: 'The size of uploaded file cannot exceed 5MB',
    consumerTypeInvalid: 'Invalid Customer Type',
    cancel: 'Cancel',
    submit: 'Submit',
    userPin: 'User pin',
    batchTemplate: 'Batch Template',
    entryNumbers: 'Total{0}',
    warnInfo: {
      customerName: 'Please enter the user name',
      company: 'Please enter the company name',
      mobile: 'Please enter the phone',
      mobileFormat: 'Mobile Phone Number format Error',
      email: 'Please enter your Email',
      emailFormat: 'Email Format Error',
      computerRoomName: 'Please select the data center',
      name: 'Please enter the name',
      number: 'Please enter the certificate number',
      phone: 'Please enter the phone',
      startTime: 'Please enter the start date',
      endTime: 'Please enter the end date',
      reason: 'Please fill in the reasons for entry',
      certificates: 'Please select the certificate type',
      nullNumber: 'Please enter the certificate number'
    },
    tableTitle: {
      name: 'Name',
      paperworkType: 'Certificate Type',
      paperworkNumber: 'Certificate No',
      mobile: 'Phone',
      company: 'Company Name',
      startTime: 'Entry Date',
      endTime: 'Finish Date',
      entryReason: 'Entry Reasons',
      brings: 'Accompanying Articles',
      carInfo: 'Vehicle Information',
      remark: 'Description',
      operate: 'Operation'
    },
    validateInfo: {
      spacing:
        'Interval between the start date and the end date shall not exceed 31 days',
      timeOrderOne: 'End time cannot be earlier than start time.',
      timeOrderTwo: 'Start time cannot be later than the end time',
      inputName: 'Please enter the name',
      inputPhone: 'Please enter the phone',
      wrongFormat: 'ID Card Number or Format Error',
      wrongRegion: 'The region of your ID Card is illegal',
      wrongDate: 'The date of the ID Card is illegal',
      wrongNumber: 'Your ID Card No. is illegal',
      wrongPassport: 'Passport Number Error',
      wrongLicence: 'Driving License Number Error',
      wrongMilitary: 'Military Officer Certificate Number Error'
    },
    placeholder: {
      inputName: 'Please enter the user name',
      choosePaperworkType: 'Please select the certificate type',
      inputNumber: 'Please enter the certificate number',
      inputPhone: 'Please enter the phone',
      inputCompony: 'Please enter the company name',
      chooseIn: 'Please enter the start date',
      chooseOut: 'Please enter the end date',
      chooseInReason: 'Please fill in the reasons for entry',
      chooseBrings: 'please fill in the Accompanying Articles',
      chooseCars: 'Please fill in the Vehicle Information',
      chooseRemark: 'Please enter the remarks'
    },
    addPerson: 'Add DC Entry Information'
  },
  // 服务支持
  serviceSupport: {
    supportTip:
      'The ticket does not support devices which are subject to subscription cancellation or change',
    equipmentList: 'Device List',
    serviceSupport: 'Service Support',
    personnelBurglary: 'DC Entry',
    isPersonIn: 'Please select whether or not to enter the data center',
    trues: 'Yes',
    falses: 'No',
    pleaseSubmit: 'Please submit',
    ticket: 'Ticket',
    deviceInfo: 'Device Information',
    chooseDevice: 'Add Device',
    uploadCheck:
      'Only 1 attachment can be uploaded, with the size not exceed 5MB and only the formats "xls" "xlsx" "doc" "docx" and "jpg" are supported',
    otherService: 'Please make a clear description on the service content',
    networkCinfig:
      'Please specify network configuration information such as IP address, gateway address, subnet mask, and DNS address. If there are two devices or more, you can add by attachment.',
    outDeviceIn:
      'Please make a clear description on the external device information',
    networkMaintenance:
      'Please make a clear description on the port information specified',
    deviceCheck:
      'Please make a clear description on the device information to be viewed',
    systemReload: 'Content',
    telephone: 'Please enter the phone ',
    email: 'Please enter your Email ',
    idcName: 'Please select Data Center',
    placeholderDefault: 'Please fill in {0}',
    inputForSearch: 'Please enter the condition to search',
    hasSelectDevice: '{0} device(s) has/have been selected',
    uploadShouldBe:
      'The files uploaded can only be in xls, xlsx, doc, docx and jpg formats!',
    systemImage: 'System Image',
    selectSystem: 'Please select OS',
    searchForMoreDeviceNo:
      'You can enter multiple device code that are separated by commas for search',
    collectionAccessories: 'Agency Collection of Accessories',
    expressCompany: 'Express Company',
    trackingNumbe: 'Courier Number',
    choosecollectionAccessories:
      'Please select whether or not Agency Collection of Accessories',
    inputexpressCompany: 'Please enter the express company name',
    inputtrackingNumbe: 'Please enter the tracking number',
    inputRemark: 'Please enter note context',
    processResult: 'Processing result',
    siteFeedback: 'Field Feedback',
    pleaseInput: 'Please enter',
    addDevice: 'Please add Device',
    ticketDisclaimer:
      'Excemption Clauses of JD Cloud IDC On-site Authorization Operation',
    dialogTextConsole:
      'I.Notice to Users on JD Cloud IDC Site Authorization Operation Service<br/><br/>'
      + 'Please be sure to carefully read the Clauses and agree the Declaration before using JD Cloud IDC site authorization operation service.<br/><br/>'
      + 'Any action of the user to use JD Cloud IDC site authorization operation service with any method (application system, email, phone, instant messaging software, etc.) will be deemed as '
      + 'acceptance of all the contents involved in the Declaration unconditionally. If the user has any objection against any clause of the Declaration, please stop using JD Cloud IDC site authorization operation service.<br/><br/>'
      + '1.      JD Cloud IDC site authorization operation service means that the customer’s authorizing person sends a request to JD Cloud IDC with the authorization method agreed by the parties, to operate its hosted and leased devices;<br/>'
      + '2.      Before JD Cloud IDC engineer operation service is demanded, the customer needs to describe the detailed information of operation in advance, including but not limited to device information, operation contents, operation methods, '
      + 'etc., and JD Cloud’s engineer will complete the operation according to the customer’s demand description;<br/>'
      + '3.      Before JD Cloud IDC engineer operation service is demanded, the customer shall back up the IT device system applications and data involved in the operation in advance;<br/>'
      + '4.      JD Cloud shall not be responsible for any damage to the security, stability, availability or any other properties of the device system or data during the operation by JD Cloud IDC engineer on the device specified by the customer with the method described by the customer;<br/>'
      + '5.      Before JD Cloud IDC engineer operation, JD Cloud shall not be responsible for the healthiness of the hardware and software of the device specified by the customer, and JD Cloud shall not be responsible for start system failure or damage to physical hardware, etc.;<br/>'
      + '6.      In case of system crash during the operation by JD Cloud IDC engineer as required by the customer, JD Cloud will be active but not obligated to assist the customer with the restoration of the system, and meanwhile, as the operation is unforeseeable, JD Cloud cannot guarantee the final restoration and running situation of the system;<br/>'
      + '7、     After JD Cloud IDC engineer completes operation as required by the user, the customer is suggested to change the provided user name and password information of the device system in time, and JD Cloud shall not be responsible for the subsequent stability, security and availability of the system and data of the operated device after the completion of the operation;<br/>'
      + '8、     The user is required to fill in the authorization letter again when filing a request for a certain set of device or a certain repeated operation at a different time, and the authorization letter will be finally licensed with JD Cloud IDC service desk as the written basis of the operation for the customer;<br/><br/>',
    chooseRoomName: 'Please select Data Center first',
    inputDeviceNetoff:
      'Please clearly describe the specific operations and specify the network cable to be used',
    inputDevicePoweroff:
      'Please clearly describe the specific operations and specify the power cable to be used',
    shutDown: 'Authorization Shutdown',
    isShutDown: 'Please select whether or not to authoriz shutdown',
    replacementChangeTip:
      'This type of ticket only supports online operations not requiring equipment downtime，does not support devices which are in closing or changing',
    inputCabinetView:
      ' Please make a clear description on the cabinet information to be viewed',
    inputVerifyWiringDistance:
      ' Please make a clear description on the wiring information to be verified',
    inputReplacementChange:
      'Please indicate the summary of operation steps, specification requirements and relevant cautions, and specific information can be added by uploading files',
    cabinetList: 'Cabinet List',
    cabinetInfo: 'Cabinet Information',
    chooseCabinet: 'Add Cabinet',
    addCabinet: ' Please add cabinet',
    cabinetNumCode: 'Cabinet Code',
    roomNum: 'Room Number',
    cabinetSpace: 'Cabinet Space (U)',
    cabinetType: 'Cabinet Type',
    hasSelectCabinet: ' {0} cabinet(s) has/have been selected',
    searchForMoreCabinetNo:
      'You can enter multiple cabinet numbers that are separated by commas for search',
    searchForMoreSNNo:
      'You can enter multiple SN numbers that are separated by commas for search',
    accessoryInfo: 'Information of Spare Parts',
    accessoryType: 'Type of Spare Parts',
    accessoryPosition: 'Location of Spare Parts',
    addAccessory: ' Please add spare part',
    cabinetA: 'Select A-terminal Cabinet',
    cabinetB: 'Select B-terminal Cabinet',
    xCabinetNumCode: '{0}-terminal Cabinet Code',
    xRoomNum: '{0}-terminal Room Number',
    sameABCabinet:
      ' The combination of Port A and Port B cabinets already exists. Please select again',
    sameAACabinet:
      ' Port A cabinet is the same as Port B cabinet. Please select again',
    checkAccessoryInfo: ' Please confirm the spare part information',
    accessoryInfoTable: ' Table of Spare Part Information',
    modifyRemark: ' Modify Notes',
    chooseAccessoryType: 'Please select Type of Spare Parts',
    inptuAccessoryPosition: 'Please enter locations of spare parts',
    other: ' Others',
    hardDisk: ' Specify hard disk slot information',
    powerSupply: ' Specify power supply slot information',
    opticalModule: ' Specify module port number',
    board: ' Specify board card slot information',
    typeAndPosition: 'Up to 10 pieces of spare part information are supported',
    maxCabinet: ' Up to 100 pieces of cabinet information are supported',
    searchCabinetNo: 'Please enter the cabinet code to search',
    searchRoomNo: 'Please enter the room number to search',
    searchDeviceNo: 'Please enter the device code to search',
    searchSNNo: 'Please enter the SN number to search'
  },
  // 故障提报
  faultReport: {
    faultReportTip:
      'The ticket does not support devices which are subject to subscription cancellation or change',
    equipmentList: 'Device List',
    personnelBurglary: 'DC Entry',
    isPersonIn: 'Please select whether or not to enter the data center',
    trues: 'Yes',
    falses: 'No',
    pleaseSubmit: 'Please submit ',
    deviceInfo: 'Device Information',
    chooseDevice: 'Add Device',
    uploadCheck:
      'Only 1 attachment can be uploaded, with the size not exceed 5MB and only the formats "xls" "xlsx" "doc" "docx" and "jpg" are supported',
    idcName: 'Please select Data Center',
    placeholderDefault: 'Please fill in {0}',
    courierType: 'Agency Collection of Accessories',
    courierCompany: 'Express Company',
    courierCode: 'Courier Number',
    selectCollectingAcce: 'Please select Agency Collection of Accessories',
    placeholderInputDefault: 'Please enter {0}',
    deviceNo:
      'You can enter multiple device code that are separated by commas for search',
    remark: 'Please enter the fault description',
    computerRoomName: 'Please select Data Center first',
    device: 'Please select the device'
  },
  // 设备迁入
  equipmentMoveIn: {
    text: {
      selfEquipment: 'Own',
      dialogTitle:
        'Exemption Clauses of JD Cloud IDC Authorization and Device Change Operation',
      onShelfType: 'Immigration Method',
      // 控制台
      readAndAgreeConsole: 'I have Read and Agreed',
      moveInDate: 'Immigration Date',
      readAndAgree: 'I have Read and Agreed',
      batchTemplate: 'Batch Template',
      userPin: 'User Pin',
      personnelBurglary: 'DC Entry',
      templateDownload: 'Template Download',
      batchImport: 'Batch Upload',
      save: 'Save',
      del: 'Delete',
      edit: 'Edit',
      deviceList: 'Device List',
      info: 'Tips'
    },
    speechCraft: {
      onlySelfEquipment:
        'This ticket only supports self-prepared devices to move-in',
      dialogText:
        '此类工单需要客户出具免责声明，请确保线下已经跟客户沟通并通过邮件方式获取到客户提供的免责声明。',
      // 控制台
      dialogTextConsole:
        'I.Notice to Users on JD Cloud IDC Site Authorization Operation Service<br/><br/>'
        + 'Please be sure to carefully read the Clauses and agree the Declaration before using JD Cloud IDC site authorization operation service.<br/><br/>'
        + 'Any action of the user to use JD Cloud IDC site authorization operation service with any method (application system, email, phone, instant messaging software, etc.) will be deemed as '
        + 'acceptance of all the contents involved in the Declaration unconditionally. If the user has any objection against any clause of the Declaration, please stop using JD Cloud IDC site authorization operation service.<br/><br/>'
        + '1.      JD Cloud IDC site authorization operation service means that the customer’s authorizing person sends a request to JD Cloud IDC with the authorization method agreed by the parties, to operate its hosted and leased devices;<br/>'
        + '2.      Before JD Cloud IDC engineer operation service is demanded, the customer needs to describe the detailed information of operation in advance, including but not limited to device information, operation contents, operation methods, '
        + 'etc., and JD Cloud’s engineer will complete the operation according to the customer’s demand description;<br/>'
        + '3.      Before JD Cloud IDC engineer operation service is demanded, the customer shall back up the IT device system applications and data involved in the operation in advance;<br/>'
        + '4.      JD Cloud shall not be responsible for any damage to the security, stability, availability or any other properties of the device system or data during the operation by JD Cloud IDC engineer on the device specified by the customer with the method described by the customer;<br/>'
        + '5.      Before JD Cloud IDC engineer operation, JD Cloud shall not be responsible for the healthiness of the hardware and software of the device specified by the customer, and JD Cloud shall not be responsible for start system failure or damage to physical hardware, etc.;<br/>'
        + '6.      In case of system crash during the operation by JD Cloud IDC engineer as required by the customer, JD Cloud will be active but not obligated to assist the customer with the restoration of the system, and meanwhile, as the operation is unforeseeable, JD Cloud cannot guarantee the final restoration and running situation of the system;<br/>'
        + '7、     After JD Cloud IDC engineer completes operation as required by the user, the customer is suggested to change the provided user name and password information of the device system in time, and JD Cloud shall not be responsible for the subsequent stability, security and availability of the system and data of the operated device after the completion of the operation;<br/>'
        + '8、     The user is required to fill in the authorization letter again when filing a request for a certain set of device or a certain repeated operation at a different time, and the authorization letter will be finally licensed with JD Cloud IDC service desk as the written basis of the operation for the customer;<br/><br/>'
        + 'II.Notice to Users on JD Cloud IDC Hosted Device Change Service:<br/><br/>'
        + 'Please be sure to carefully read the Clauses and agree the Declaration before using JD Cloud IDC hosted device change service.<br/><br/>'
        + 'Any action of the user to use JD Cloud IDC hosted device change service with any method (application system, email, phone, instant messaging software, etc.) will be deemed as acceptance of all the contents involved in the Declaration unconditionally. If the user has any objection against any clause of the Declaration, please stop using JD Cloud IDC hosted device change service.<br/><br/>'
        + '1、     JD Cloud IDC hosted device change service means that the customer’s authorizing person sends a request to JD Cloud IDC with the method agreed by the parties, to launch, remove and change the location of its hosted and leased devices;<br/>'
        + '2、     Before JD Cloud IDC hosted device change service is demanded, the customer needs to describe the detailed information of the change service in advance, including but not limited to hosted data center, cabinet location, device model, IP address, change method, network cable connection method and other requirements, and JD Cloud’s engineer will complete the operation according to the customer’s demand description;<br/>'
        + '3、     JD Cloud IDC engineer will verify the information after accepting the service request, with the contents including cabinet location, IT device compliance, cabinet space\\power availability, and will execute the customer’s service request only after the above contents are verified and confirmed;<br/>'
        + '4、     Before JD Cloud IDC engineer operation, JD Cloud shall not be responsible for the healthiness of the hardware and software of the IT device, and JD Cloud shall not be responsible for start system failure, configuration information error or damage to physical hardware;<br/>'
        + '5、     When JD Cloud IDC engineer carry out change operation on IT device, the customer shall be on site for cooperation, and after IT device change, JD Cloud IDC engineer will issue the Device Change Confirmation Sheet for the operation as the service voucher. The customer shall sign for confirmation after verifying the Sheet as correct. The Device Change Confirmation Sheet shall be made in duplicate, one for JD Cloud IDC for archiving, one for the customer for keeping. If the customer cannot arrive at the site, the electronic version of the Device Change Confirmation Sheet will be sent by JD Cloud IDC engineer to the customer’s email, and the customer shall print the Sheet, sign for confirmation, and send the electronic scanning copy back to JD Cloud or send the signed copy by facsimile back to JD Cloud;<br/>'
        + '6、     If the customer’s IT device is sent to the Data Center by postexpress, and entrusts JD Cloud IDC engineer to sign for receipt, the customer is required to inform of the logistics carrier, bill number, number of goods cabinets, customer’s contact information and other information in advance. After the goods arrive at the Data Center, JD Cloud IDC engineer is only responsible for making an inventory of the number of goods cabinets and accepting the external packaging, rather than the number and healthiness of the IT device and fittings in the packaging box;<br/>'
        + '7、     If the customer requests to remove the IT device, the customer is required to shut down the IT device on site; if the customer cannot arrive at the site, the customer is required to shut down the IT device before the removal of IT device remotely, and the on-site JD Cloud IDC engineer shall confirm the status of IT device before removal. If the customer requests JD Cloud IDC engineer to shut down the IT device by the means of forced shutdown, JD Cloud will not be responsible for the interruption of and damage to the operated IT device’s software and hardware, the application system and the data;<br/>'
        + '8、     Each request filed by the user for JD Cloud IDC hosted device change shall be a request for only one single operation, the user is required to fill in the authorization letter again when filing a request for device change to a different IT device or at a different time, and the authorization letter will be finally licensed with JD Cloud IDC service desk as the written basis of the operation for the customer;<br/><br/>',
      uploadFile:
        'Only 1 attachment can be uploaded, with the size not exceed 5MB and only the formats "xls" "xlsx" "doc" "docx" and "jpg" are supported'
    },
    placeholder: {
      onShelfType: 'Please select the immigration method',
      customerName: 'Please enter Customer Name',
      customerCode: 'Please enter Customer Code',
      userPin: 'Please enter user pin',
      companyName: 'Please enter Company Name',
      telephone: 'Please enter the phone',
      email: 'Please enter the email',
      correctEmail: 'Please enter correct email',
      idcName: 'Please select the data center',
      moveInDate: '请选择迁入日期',
      note: 'content',
      cabinetNo: 'Please enter the cabinet code',
      assetStatus: 'Please select the asset category ',
      model: 'Please enter the model',
      brand: 'Please enter the brand',
      deviceIn: 'Please select immigrated device',
      uNo: 'Please enter the U number',
      uOnlyNumber: 'U number shall be numbers only',
      deviceType: 'Please select the device type',
      snNo: 'Please enter SN Number',
      snCantChina: 'The SN number shall not be given in Chinese',
      phone: 'Please enter phone number',
      correctPhone: 'Please enter correct phone number',
      deviceInDate: 'Please select the immigration date',
      personIn: 'Please select whether or not to enter the data center',
      snNoRepeated: 'The SN number can not be repeated',
      onlyValid:
        'The device immigration only supports cabinets that have already completed initialization.',
      makeSure:
        'Please make sure that the device immigration and transported after verification. JD Cloud does not provide device preservation service.'
    }
  },
  // 设备异动
  equipmentMove: {
    text: {
      moveDate: 'Migration Date',
      moveType: 'Migration Method',
      currentCabinet: 'Current Cabinet',
      currentUBit: 'Current  Location',
      targetCabinet: 'New Cabinet',
      targetUBit: 'New Location',
      chooseMove: 'Select Migration Device',
      deviceNoRepeated: 'Device Code can not be repeated',
      moveDevice: 'Migration Device',
      nextStep: 'Next step',
      finish: 'Finish',
      equipmentMove:
        'This ticket only supports move-out of self-prepared devices which have been placed on the shelves'
    },
    placeholder: {
      moveType: 'Please select Migration Method',
      moveDate: 'Please select the date of change',
      moveDevice: 'Please select emigrated device',
      chooseInCabinet: 'Select New Cabinet',
      example: 'Please enter For example：13-13',
      deviceNoRepeated: 'Device Code can not be repeated'
    }
  },
  // 带宽流量
  bwTraffic: {
    traffic: 'Bandwidth Traffic',
    name: 'Bandwidth Name',
    totalUpRealTraffic: 'Total Uplink Real-time Traffic',
    totalDownRealTraffic: 'Total Downlink Real-time Traffic',
    totalBandwidth: 'Total Bandwidth',
    helpDoc: '{0}  Documentation',
    controlChart: 'Monitoring Graph',
    resourceInfo: 'Resource Information',
    controlInfo: 'Monitoring Information',
    switchInfo: 'Interchanger Information',
    switchIP: 'Interchanger IP',
    port: 'Port Number',
    upRealTraffic: 'Uplink Real-time Traffic',
    downRealTraffic: 'Downlink Real-time Traffic',
    relateIP: 'Associated Public IP',
    IPAddress: 'IP Address',
    lineType: 'ISP Line Type',
    trafficUnit: 'Traffic（Mbps）',
    all: 'All',
    selectDateRange: 'Select time range for search',
    powerTrendChart: 'Bandwidth Traffic Trend Chart',
    noPermission:
      'You did not enable this function, please contact the administrator.',
    trafficDetail: 'Bandwidth Traffic Details',
    day31range:
      '（You can query the data within 90 days, up to 31 days of continuous data query.）',
    ipAndPort: '{0}&{1}'
  },
  // 报警规则
  alarm: {
    port: 'port',
    pop: 'pop',
    popTip: 'According to the unread alarm for exports, including the total number of ports for export orders.',
    alarmObject: 'Alarm Object',
    alarmRules: 'Alarm Rules',
    rulesName: 'Rule Name',
    rulesDetail: 'Details of Rules',
    resourceType: 'Resource Type',
    resourceName: 'Resource Name',
    condition: 'Alarm Condition',
    ifnameTypeName: 'Monitoring Item',
    noticePeriod: 'Notification Period',
    notificationObject: 'Notification Object',
    noticeMethod: 'Notification Method',
    noticeMethodNotEmpty: 'Notification Method cannot be blank',
    strategyStatusName: 'Rule Status',
    modification: 'Modify',
    disable: 'Disable',
    period: 'Period',
    statisticMethod: 'Statistical Method',
    expressionOp: 'Calculation Method',
    use: 'Enable',
    alarmHistory: 'Alarm History',
    add: 'Add an alarm rule',
    modificationTip: 'Please enable the alarm rule at first',
    set: 'Set alarm rules',
    relationResource: 'Associated Resource',
    alarmRulesSetting: 'Setting of Alarm Rule',
    notifyObjectSetting: 'Setting of Notification Object',
    ipAndPort: 'Interchanger IP & Port Number',
    addStepOneTip:
      'Setting of the same rule is supported by each switch & port number and only independent alarm is supported only, excluding the sum.',
    next: 'Next',
    prev: 'Back',
    finish: 'Finish',
    choose: 'Please select the {0}',
    contactsPeople: 'Contacts',
    contactsGroup: 'Contact Groups',
    rulesNameMessage:
      '1-32 characters, only supports Chinese, numbers, uppercase and lowercase letters, English underline “_” and line-through “-””',
    touchCount: 'Trigger the alarm successively for several times',
    clear: 'Clear',
    expressionValue: 'Threshold',
    expressionValueErrorTip:
      'The threshold must be numeric and larger than 0, and the precision contains up to two digits after the decimal point',
    expressionValueErrorTipLimit: 'Threshold exceeds the cap. Please re-enter',
    allContactsPeople: 'All Contacts',
    allContactsGroup: 'All Contacts Groups',
    selectedContactsPeople: 'Selected Contacts',
    selectedContactsGroup: 'Selected Contacts Groups',
    searchName: 'Please enter the name to search',
    searchGroupName: 'Please enter the group name to search',
    phone: 'Mobile',
    peopleNum: 'Number',
    groupName: 'Group name',
    contactsOptTip:
      'Note: Add and modify contacts and contact groups in Contact Management',
    contactsManager: 'Contact Management',
    nameDuplicated: 'Name Duplicated',
    times: 'times'
  },
  // 报警历史
  alarmHistory: {
    alarmInfo: 'Alarm Information',
    alarmTime: 'Occured At',
    resourceType: 'Resource Type',
    resourceName: 'Resource Name',
    alarmCondition: 'Alarm Condition',
    alarmValue: 'Alarm Value',
    ipAndPort: 'Interchanger IP & Port Number',
    alarmObject: 'Alarm Object',
    alarmStatus: 'Alarm Status',
    alarmRule: 'Alarm Rules',
    alarmRuleName: 'Rule Name',
    ruleStatus: 'Rule Status',
    notificationPersion: 'Notification Object',
    notificationPeriod: 'Notification Period',
    helpDoc: '{0}  Documentation',
    alarmHistory: 'Alarm History',
    dataRange: 'Select time range for search',
    close: 'Close',
    index: 'SN',
    phone: 'Mobile',
    contactsPeople: 'Contacts',
    contactsGroup: 'Contact Groups',
    prompt: 'notification',
    optionRule: 'Confirm to {0} the alarm rule : {1}?',
    contactsGroupName: 'Group name',
    groupNumber: 'Number',
    showGroupInfo: 'View contact groups information in',
    countManagement: ' Contact Management',
    toOperation: '',
    more: 'More'
  },
  expressDelivery: {
    estimatedArrivalDate: 'Expected Delivery Date',
    estimatedPickupDate: 'Expected Pickup Date',
    packageList: 'Package List',
    packageListInfo: 'Package List',
    sendListInfo: 'Shipping List',
    sendList: 'Shipping List',
    goodsList: 'List of the Goods',
    goodsType: 'Type of the Goods',
    goodsDesc: 'Description of the Goods',
    goodsDescPlaceholder:
      'Please add necessary information on describing the goods such as the name, brand, model, and quantity of the goods',

    goodsDescOtherPlaceholder:
      'Please add necessary information on describing the goods such as the name, brand, and model of the goods',
    harvesinfo: 'Receipt Information',
    shippingAddress: 'Delivery Address',
    recipient: 'Consignee',
    sender: 'Consignor',
    recipientMobile: 'Phone Number',
    choose: 'Please select the {0}',
    courier: 'Courier',
    recipientContacts: 'Consignee',
    placeholderInputDefault: 'Please enter {0}',
    courierCompanyMessage:
      '1-32 characters, only supports Chinese, numbers, uppercase and lowercase letters',
    recipientCompanyMessage:
      '1-32 characters, only supports Chinese, uppercase and lowercase letters',
    courierCodeTip:
      'One ticket only supports one express logistics ticket number',
    notEmpty: '{0}cannot be blank',
    remark: 'Please enter the description',
    courierTip:
      'The courier pickup personnel shall provide identification documents',
    description: 'Description',
    idcAddress: ' Data Center Address',
    deliveryinfo: 'Shipping Information',
    remarkMessage: 'Please enter the description',
    idcManagerPhone: 'DC Duty Calls',
    maturityRange: 'Only the arrival date within 3 days is supported',
    checkPackageListInfo: 'Please confirm the package list information',
    checkSendListInfo: 'Please confirm the package list information',
    isReceived: 'Received or Not',
    storageLocation: 'Storage Location',
    storageDesc: 'Storage Description',
    isSend: 'Shipped or Not',
    packageInfoLenMessage: 'Up to {0} pieces can be added',
    snNoRepeat: 'SN shall not be repeated',
    checkNumberOver: 'No more than {0} items can be submitted each time.',
    ticketDisclaimer:
      'Excemption Clauses of JD Cloud IDC Device Courier Operation',
    dialogTextConsole:
      'I.Notice to Users on JD Cloud IDC Data Center Customer Device Courier Service:      <br/><br/>'
      + 'Please be sure to carefully read the Clauses and agree the Declaration before using JD Cloud IDC Data Center Customer Device Courier Service.      <br/><br/>'
      + 'Any action of the user to use JD Cloud IDC Data Center Customer Device Courier Service with any method (application system, email, phone, instant messaging software, etc.) will be deemed as an acceptance of all the contents involved in the Declaration unconditionally. If the user has any objection against any clause of the Declaration, please stop using JD Cloud IDC Data Center Customer Device Courier Service.      <br/><br/>'
      + '1、     JD Cloud IDC Data Center Customer Device Courier Service means that the customer’s authorizing person sends a request to JD Cloud IDC with the method agreed by the parties, to deliver its hosted or leased device to the designated location through a third-party logistics company;      <br/>'
      + '2、     Before JD Cloud IDC Data Center Customer Device Courier Service is demanded, the customer needs to describe the detailed information of the couriered device in advance, including but not limited to hosted Data Center, cabinet location, device U position, device model, SN number, and off-shelf time; in addition, relevant information of third-party logistics carrier supplier is required to be provided, including the logistics company name, carrier identity certificate, delivery destination, equipment insured value, logistics packaging method and other information; and JD Cloud’s engineer will take the hosted device off the shelf according to the customer’s demand description and deliver it to the logistics personnel designated by the customer;      <br/>'
      + '3、     The JD Cloud IDC engineer will verify the information after accepting the service request, covering cabinet location, device U position, device model, SN and other contents, and will execute the customers’ service request after verification and confirmation;      <br/>'
      + '4、     Before delivering the IT device via express, the customer needs to turn off the IT device remotely and the field JD Cloud IDC engineer shall confirm running status of the IT device before removing such devices. If the customer requests JD Cloud IDC engineer to shut down the IT device by means of forced shutdown, JD Cloud will not be responsible for the interruption of and damage to the operated IT device’s software and hardware, the application system and the data;      <br/>'
      + '5、     After removing the IT device, the JD Cloud IDC engineer will issue the Device Change Confirmation Sheet for this operation as the certificate of service. If the customer does not present at the site, the Device Change Confirmation Sheet will be sent to the customer’s email box electronically by the JD Cloud IDC engineer, and the customer shall check, print and sign the same for confirmation as well as send the same back to JD Cloud in the form of electronic scanning or fax. The Device Change Confirmation Sheet shall be made in duplicate, with one kept by JD Cloud IDC for filing and the other one kept by the customer for preservation;      <br/>'
      + "6、     After the customer's IT device is delivered to the logistics carrier designated by the customer, the logistics company shall be responsible for the transportation follow-up, integrity, arrival time, etc. and JD Cloud will not assume any relevant responsibility;      <br/>"
      + '7、     Each request filed by the user for JD Cloud IDC hosted device courier service shall be a request for only one single operation. The user is required to fill in the authorization letter again when filing a request for device courier service of a different IT device or at a different time, and the authorization letter will be finally licensed with JD Cloud IDC service desk as the written basis of operation for the customer;      <br/>'
      + '8、     Before using JD Cloud IDC Data Center Customer Device Courier Service, the customer shall negotiate the price and payment issues with the third-party logistics company and JD Cloud IDC engineer will neither negotiate the price for logistics nor advance any cost;      ;<br/><br/>'
  },
  cabinetPowerUp: {
    powerUpTime: 'Target enabling time',
    powerStatus: 'Enabling Status',
    form: {
      powerUpTime: 'please select the target enabling time'
    }
  },
  cabinetReservation: {
    apply: 'Reserved Resource',
    applyTime: 'Reservation Time',
    applyNum: 'Reservation Count',
    addList: 'Add to List',
    applyList: 'List of Reserved Resource',
    cabinetPower: 'Cabinet Power',
    unit: 'Unit',
    one: 'R',
    space: 'Space',
    power: 'Power',
    reserveTip: 'End time of reserved resources',
    cabinetSpace: 'Cabinet Space',
    productName: 'Product Name',
    handleTips: {
      inputIDCRoom: 'Please input or select Data Center',
      reserveTip: 'Please select end time of reserved resources',
      cabinetPower: 'Please select cabinet power',
      cabinetSpace: 'Please select cabinet space',
      reserveReq: 'Please select reservation requirement',
      cabinetType: 'Please select cabinet Type'
    },
    reserveReq: 'Reservation Requirement',
    cabinetType: 'Cabinet Type'
  },
  // 机柜购买
  create: {
    text: {
      yearlyOrMonthly: 'Monthly Package',
      regionAndAz: 'Region and Co-locaiton zone',
      region: 'Region',
      az: 'Co-locaiton zone',
      dc: 'Data Center',
      specs: 'Type',
      cabinetType: 'Categories',
      spec: 'Specification',
      cabinetRoom: 'Cabinet Space',
      current: 'Current',
      buy: 'Cabinet Purchase',
      buyNum: 'Quantity',
      buyTimeSpan: 'Duration',
      count: 'Quantity',
      year: 'year | years',
      soldOut: 'Sold out',
      cost: 'Cost',
      selectedConfig: 'Selected Configuration',
      buyNow: 'Buy Now',
      yearUnit: 'year | years',
      calculating: 'Calculating...',
      original: 'Original Amount',
      save: 'Save'
    },
    hover: {
      count: 'The maximum quantity for each order is 10'
    },
    help: {
      soldOut: 'Sold out! ',
      noCertification:
        'Enterprise real-name verification is required for the product you purchase. Please purchase the product after verification.',
      goCertificate: 'Go to verify',
      restock: 'Replenishing!',
      contact: 'Please call the customer service at 400-615-1212 (7*24h) .',
      notEnough: 'Insufficient resources. Please try to reduce the quantity, ',
      orContact: 'or call the customer service at 400-615-1212 (7*24h) .'
    }
  },
  cabinetPowerOff: {
    powerOffNeed: 'Power-off Reason',
    cabinetNeed: 'The power-off cabinet will serve as the customer’s Reserve',
    powerOffTime: 'Expected Power-off Time',
    powerOffTip: 'Power-off confirmation',
    powerOffTips:
      ' All relevant devices (servers, network devices, etc.) on the power-off cabinet have been off-line physically or their businesses are off-line.',
    powerOffTipAll:
      'Power-off instructions: Please confirm that all relevant devices (servers, network devices, etc.) on the power-off cabinet have been off-line physically or their businesses are off-line.',
    unsubscribe: 'Unsubscribe Resource',
    addCabinetsTip:
      'Note: Please open a device move-out/displacement ticket and then remove the device from the cabinet. Only the cabinet without any device can be off-lease.',
    applyEndTime: 'Reserve End Time',
    needAndRoom: 'Please select reserve demand and Data Center name first',
    confirm: 'Confirmed',
    notice: 'Power-off instructions',
    form: {
      powerOffNeed: 'Please select Power-off Reason',
      powerOffTime: 'Please select Expected Power-off Time',
      applyEndTime: 'Please select Reserve End Time',
      confirm: 'Please confirm Power-off',
      applyEndTimeChecker:
        'Reserve End Time greater than or equal Expected Power-off Time'
    },
    cabinetType: 'cabinet Type'
  },
  GeneralServices: {
    remarks:
      'Please enter service content, such as move-in and move-out of devices as well as reboot of devices, and supplementary information',
    count: 'Count',
    deviceTip: '(Not required for non-device demand)',
    snNoRepeated: 'The SN number can not be repeated'
  },
  equipmentUnsubscribe: {
    unsubscribeTime: 'Expected Subscription Cancellation Time',
    dataBackup: 'Data Backup Confirmation',
    dataErasure: 'Data Wiping Confirmation',
    dataBackupNotice:
      'Customers back up business data of relevant devices (servers, network device, etc.) on their own.',
    dataErasureNotice:
      'Customers wipe business data of relevant devices (servers, network device, etc.) on their own.',
    unsubscribeNotice:
      'Subscription cancellation notice: Please confirm that data backup of relevant devices (server, network device, etc.) has been completed and data has been wiped. JD Cloud will not be responsible for data loss (if any).',
    form: {
      confirm: 'Please confirm',
      unsubscribeTime: 'Please select Expected Subscription Cancellation Time',
      outsideIDC: 'Please enter External Data Center Address',
      outsideContact: 'Please enter Contact Person of External Data Center',
      outsideMobile: 'Please enter Contact Phone Number of External Data Center'
    },
    outsideIDC: 'External Data Center Address',
    outsideContact: 'Contact Person of External Data Center',
    outsideMobile: 'Contact Phone Number of External Data Center',
    chooseDevice: 'Choose subscription cancellation device'
  },
  deviceOpen: {
    jiaofuziyuan: 'Deliver Resource',
    jiaofuziyuanList: 'Deliver Resource List',
    addjiaofuziyuan: 'Add Deliver Resource',
    addDisk: 'Add Disk',
    requestAddjiaofuziyuan: 'Please add Deliver Resource',
    chanpinguige: 'Specifications',
    xuanzechanpin: 'select product',
    config: 'Configuration',
    wulicpu: 'Physical CPU',
    storage: 'Memory',
    disk: 'Disk',
    diskArray: 'RAID Card',
    network: 'Network Interface',
    diskType: 'Type',
    diskVolume: 'Unit Capacity',
    configRemark: 'Configuration Requirements',
    discription:
      'Please enter a required specification. If you require multiple specifications, please add them one by one to the delivery list',
    jiaofushuliang: 'Delivery Quantity',
    addList: 'Add to List',
    selectConfig: 'Please select at least 1 disk'
  },
  menu: {
    resource: 'Resource Management',
    ticket: 'Ticket Management',
    monitor: 'Monitoring Alarm',
    alarm: 'Alarm Management',
    consumption: 'Consumption Management',
  }
};



// WEBPACK FOOTER //
// ./src/lib/i18n-en-US.js